import { render } from "./CheckoutButton.vue?vue&type=template&id=1879e215&scoped=true&ts=true"
import script from "./CheckoutButton.vue?vue&type=script&lang=ts"
export * from "./CheckoutButton.vue?vue&type=script&lang=ts"

import "./CheckoutButton.vue?vue&type=style&index=0&id=1879e215&lang=scss&scoped=true"

import exportComponent from "/Users/gerald/Projects/designium/RandselSimulation/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1879e215"]])

export default __exports__